import { useState, useMemo } from "react";
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from '../_metronic/i18n/i18nProvider';
import { LayoutProvider } from '../_metronic/layout/core';
import { Routes } from './routing/Routes';
import { ErrorbyId, } from './Components/Error/Error';
import { MessagebyId } from './Components/Message/Message';
import { SessionContext } from './Components/Context/SessionContext';
import { FeedbackContext } from './Components/Context/FeedbackContext';
import Auth from './Components/Auth/Auth'

const App = (props) => {

  const [feedbackContext, setFeedbackContext] = useState({ idError: null, showError: false, idMessage: null, showMessage: false, callback: () => { } });
  const feedbackProviderContext = useMemo(() => ({ feedbackContext, setFeedbackContext }), [feedbackContext, setFeedbackContext]);

  const [session, setSession] = useState({
    "email": null,
    "name": null,
    "role": null,
    "userState": null,
    "idUsuarioLocatario": null,
    "sessionToken": null,
    "role_name": null,
    //"permissions": null,
    "roleList": null,
  });
  const sessionProviderContext = useMemo(() => ({ session, setSession }), [session, setSession]);

  return (
    <BrowserRouter basename={props.basename}>
      <I18nProvider>
        <LayoutProvider>
          <SessionContext.Provider value={sessionProviderContext}>
            <FeedbackContext.Provider value={feedbackProviderContext}>
              <Auth>
                <Routes />
                <MessagebyId ></MessagebyId>
                <ErrorbyId ></ErrorbyId>
              </Auth>
            </FeedbackContext.Provider>
          </SessionContext.Provider>
        </LayoutProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}


export { App }
